export const PR = {
  ApplicationCode: '#{ApplicationCode}#',
  BaseUrl: '#{BaseUrl}#',
  SubscriptionKey: '#{SubscriptionKey}#',
  SimulationRedirectUrl: '#{SimulationRedirectUrl}#',
  LeadsUrl: '#{LeadsUrl}#',
  leadsVariables : {
    leadsUser : '#{LeadsUser}#',
    leadsSubscriptionKey : '#{LeadsSubscriptionKey}#',
    leadsAipSubscriptionKey : '#{LeadsAipSubscriptionKey}#',
  },
  Brand: '#{Brand}#',
  BranchCode: '#{BranchCode}#',
  Channel: '#{Channel}#',
  Company: '#{Company}#',
  CompanyAgeas: '#{CompanyAgeas}#',
  Country: '#{Country}#',
  CoreSystem: '#{CoreSystem}#',
  DOC1: '#{DOC1}#',
  REDDOC: '#{REDDOC}#',
  documentCode: '#{documentCode}#',
  Language: '#{Language}#',
  Currency: '#{Currency}#',
  ProductCode: '#{ProductCode}#',
  ProductCodeVersion: '#{ProductCodeVersion}#',
  PaymentListMaxRetry: '#{PaymentListMaxRetry}#',
  PaymentListRetryTimer: '#{PaymentListRetryTimer}#',
  Environment: '#{Environment}#',
  DangerousBreedQuestion: '#{DangerousBreedQuestion}#',
  FillDataForSimulation: {
    Channel: '#{ChannelFillDataForSimulation}#',
    Company: '#{CompanyFillDataForSimulation}#',
  },
  CreateProposal: {
    Channel: '#{ChannelCreateProposal}#',
    Company: '#{CompanyCreateProposal}#',
  },
  CreatePolicyholder: {
    Company: '#{CompanyCreatePolicyholder}#',
  },
  AcceptConditions: {
    Channel: '#{ChannelAcceptConditions}#',
    Company: '#{CompanyAcceptConditions}#',
  },
  SubmitProposal: {
    Channel: '#{ChannelSubmitProposal}#',
  },
  AdditionalEntityDetailsForSummaryDocument: {
    Company: '#{CompanyAdditionalEntityDetailsForSummaryDocument}#',
    Channel: '#{ChannelAdditionalEntityDetailsForSummaryDocument}#',
  },
  AdditionalEntityDetails: {
    Company: '#{CompanyAdditionalEntityDetails}#',
    Channel: '#{ChannelAdditionalEntityDetails}#',
  },
  SendSimulationSummaryByEmail: {},
  RecalculatePremium: {
    Channel: '#{ChannelRecalculatePremium}#',
    DistributionChannel: '#{DistributionChannelRecalculatePremium}#',
  },
  GetEntityDetails: {
    Channel: '#{ChannelGetEntityDetails}#',
  },
  RequestQuotation: {
    Language: '#{LanguageRequestQuotation}#',
    Company: '#{CompanyRequestQuotation}#',
  },
  SimulationSummaryDownload: {
    BranchCodeSimulationSummary: '#{BranchCodeSimulationSummary}#',
    CompanyCodeSimulationSummary: '#{CompanyCodeSimulationSummary}#',
  },
  GenerateProposalDocuments: {
    BranchCodeGenerateProposal: '#{BranchCodeGenerateProposal}#',
    CompanyCodeGenerateProposal: '#{CompanyCodeGenerateProposal}#',
  },
  Payment: {
    channel: '#{ChannelPayment}#',
  },
  CoverageId: {
    Vaccine: '#{CoverageIdVaccine}#',
    AnimalCustody: '#{CoverageIdAnimalCustody}#',
    OrganizationFuneralServices: '#{CoverageIdOrganizationFuneralServices}#',
    VariousInformation: '#{CoverageIdVariousInformation}#',
    LegalDefense: '#{CoverageIdLegalDefense}#',
  },
}
